import "./chip.css";

const trackPointer = (e) => {
 const rect = e.currentTarget.getBoundingClientRect();
 e.currentTarget.style.setProperty("--px", `${e.clientX - rect.left}px`);
 e.currentTarget.style.setProperty("--py", `${e.clientY - rect.top}px`);
};

export function Chip({ props }) {
 return (
  <div className="chip-container" title={props.name} onMouseMove={trackPointer}>
   <img src={props.icon} className="chip-img" alt={props.name || "Technology"} loading="lazy" />
   {props.name && <span className="chip-name mono">{props.name}</span>}
  </div>
 );
}
